<app-button-advanced
  class="action-button"
  [action]="polygonAction"
  [active]="
    ['CustomPolylineFreehand'].includes(
      (stateManagerProjectService.currentTool$ | async)!
    )
  "
  [displayCorner]="settings.displayCorner"
  (clickedByCorner)="
    stateManagerProjectService.currentStateOfToolMenu = 'LASSO';
    menuTrigger.openMenu()
  "
  matTooltip="{{ 'viewer.Tools.Polygon' | translate }}"
  [matTooltipPosition]="'left'"
  [hotButton]="settings.displayHotKey ? 'L' : ''"
  [isMenuOpened]="menuTrigger.menuOpen"
  [matTooltipDisabled]="settings.disableTooltip || (isDisabled$ | async)"
  (contextmenu)="onLassoActionContextMenu($event)"
></app-button-advanced>

<span
  #menuTrigger="matMenuTrigger"
  class="hidden-menu-trigger"
  [matMenuTriggerFor]="(isDisabled$ | async) ? null : polygonSettingsMenu"
>
</span>
<mat-menu
  #polygonSettingsMenu
  [xPosition]="settings.menuPosition.x"
  [yPosition]="settings.menuPosition.y"
  [hasBackdrop]="!settings.hideMenuBackdrop"
  class="base-tool-menu {{ settings.menuClass ?? '' }}"
  (closed)="updateComponent()"
>
  <button
    [ngClass]="{
      'active-item':
        stateManagerProjectService.currentPolylineMode === 'DEFAULT'
    }"
    (click)="changePolylineMode('DEFAULT')"
    class="lasso-menu-button"
  >
    <div class="lasso-menu-button-item">
      <div>Default</div>
      <div>(L)</div>
    </div>
    
  </button>
  <button
    [ngClass]="{
      'active-item':
        stateManagerProjectService.currentPolylineMode === 'SUBTRACT'
    }"
    (click)="changePolylineMode('SUBTRACT')"
    class="lasso-menu-button"
    >
    <div class="lasso-menu-button-item">
      <div>Subtract</div>
      <div>(-)</div>
    </div>
  </button>
</mat-menu>
